export const ACCESS_REASONS = [
  "signed-out", "no-membership", "pending-join", "no-selected-team",
  "missing-entitlement", "missing-role",
];

export function createPageIdentity({ accountId = null, teamId = null, routeId, dataKey = "" }) {
  if (!routeId) throw new Error("Page identity requires a routeId.");
  return JSON.stringify([accountId, teamId, routeId, dataKey]);
}

export function validateLiveAdapter(adapter) {
  if (!adapter?.View || typeof adapter.useModel !== "function") {
    throw new Error("A live adapter must provide View and useModel.");
  }
  return adapter;
}

export function validateExampleAdapter(adapter) {
  if (!adapter?.View || adapter.model?.fictional !== true || adapter.useModel) {
    throw new Error("An example adapter must provide a pure View and a fixture model.");
  }
  return adapter;
}

// The caller supplies real navigation/contact/select-team handlers. The framework
// never changes team identity, starts a purchase, or calls a live feature action.
export function getExampleAction(reason, { canManageBilling = false } = {}) {
  const choices = {
    "signed-out": ["sign-in", "Sign in", "Sign in to use this page with your own account."],
    "no-membership": ["join-team", "Join or create a team", "Join an active team to use this feature."],
    "pending-join": ["view-team", "View team status", "Your team membership is still pending."],
    "no-selected-team": ["select-team", "Select a team", "Choose one of your teams to open this page."],
    "missing-entitlement": canManageBilling
      ? ["subscription", "Review subscription", "An active team subscription is needed for this feature."]
      : ["contact-manager", "Contact your team manager", "Ask your team manager about access to this feature."],
    "missing-role": ["contact-manager", "Contact your team manager", "Your current team role does not include this feature."],
  };
  const [id, label, description] = choices[reason] || ["view-team", "View team access", "Review your access to use this feature."];
  return { id, label, description };
}
